import React from 'react';
import {ReportingBaseFilter} from './base-filter';
import {BaseFilterProps} from './interface';

interface FeedbackFilterProps extends BaseFilterProps {}
export const ReportingFeedbackFilter = ({...rest}: FeedbackFilterProps) => {
  return <ReportingBaseFilter {...rest}></ReportingBaseFilter>;
};
